import React from 'react';
import { string, shape } from 'prop-types';
import { Query } from 'react-apollo';
import withApplicationConfig from 'containers/withApplicationConfig';
import Layout from 'components/layout';
import Queries from 'queries';
import ErrorPage from 'pages/ErrorPage';
import {
  getAuthQueryVariables, getStaticText, getImages,
} from 'helpers/Utils';

const ErrorPageQuery = ({
  errorCode,
  staticContext,
  localisation,
  language,
  contentstackKeys,
}) => {
  if (staticContext) staticContext.status = errorCode;
  return (
    <Query
      query={Queries.GetStaticPage}
      variables={{
        language: localisation[language],
        product: 'homepage',
        ...getAuthQueryVariables({
          contentstackKeys,
        }),
      }}
    >
      {({ data, refetch }) => (
        <Layout
          {...data.pageConfig}
          componentConfig={data?.componentConfig}
          seoMetadata={data.seoMetadata}
          customerProfile={data?.customerProfile}
          staticText={getStaticText(data)}
          images={getImages(data)}
          refetch={refetch}
        >
          <ErrorPage language={language} errorCode={errorCode} />
        </Layout>
      )}
    </Query>
  );
};

ErrorPageQuery.propTypes = {
  errorCode: string,
  localisation: shape({}).isRequired,
  language: string.isRequired,
  staticContext: shape({}).isRequired,
  contentstackKeys: shape({}).isRequired,
};

ErrorPageQuery.defaultProps = {
  errorCode: 404,
};

export default withApplicationConfig(ErrorPageQuery, ['languages', 'contentstackKeys']);
